import React, { PureComponent } from 'react';
import _ from 'lodash';

export default class InputField extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  static defaultProps = {
    onSubmit: () => null
  };

  handleChange(event) {
    const id = _.get(event, 'target.id', '');
    const value = _.get(event, 'target.value', '');

    this.setState({ [id]: value });
  }

  handleSubmit(event) {
    const { onSubmit } = this.props;
    onSubmit(this.state);
    event.preventDefault();
  }

  getFormClass = (field) => {
    const hasValue = !_.isEmpty(_.get(this.state, [field.fieldKey], ''));
    if (field.type === 'textArea') {
      return `form-long ${hasValue ? 'hasValue' : ''}`;
    }
    return 'form';
  };

  renderTypeInput = (props) => {
    switch (props.type) {
      case 'textArea':
        return <textarea id={props.fieldKey} onChange={this.handleChange} />;
      case 'input':
      default:
        return (
          <input
            onChange={this.handleChange}
            id={props.fieldKey}
            type="text"
            required
          />
        );
    }
  };
  render() {
    const { fields, getContentLanguage } = this.props;
    return (
      <form onSubmit={this.handleSubmit} className="input-container">
        {_.map(fields, (field) => {
          return (
            <div className={this.getFormClass(field)}>
              {this.renderTypeInput(field)}

              <div className="label">{field.name}</div>
              <div className="line" />
              <div className="t-line" />
            </div>
          );
        })}
        <div className="wrapper-secondary-btn">
          <input
            onChange={this.handleChange}
            type="submit"
            value={getContentLanguage('send')}
            className="secondary-btn"
          />
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InputField.js